import { Image, Text, View } from '@react-pdf/renderer'
import { useFormatNumber } from '../../../../hooks/useFormatNumber';
import { blankFooterStyles } from '../blankFooter/blankFooterStyles';
import { footerInLastPageStyles } from './footerInLastPageStyles';

export const FooterInLastPage = ({ data, showTranslatedText }: any) => {

    const { footerInLastPage, notes, totals } = footerInLastPageStyles();

    const { blankFooter } = blankFooterStyles();

    const { setFormatNumber } = useFormatNumber();

    return (
        <View style={footerInLastPage.container} >
            {/* Pie de pagina en ultima pagina */}
            <View style={footerInLastPage.thirdSections}>
                <View style={notes.container}>
                    <Text style={{fontWeight:700, fontSize:6}}>{showTranslatedText("reports.salesPreorderPdf.footer.notes")}:</Text>
                    <Text style={{ fontSize: 6 }}>{data.dataSalesPreorders.notes}</Text>
                </View>
                <View style={totals.container}>
                    <View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesPreorderPdf.lastPageFooter.taxes")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataSalesPreorders.tax_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesPreorderPdf.lastPageFooter.retentions")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataSalesPreorders.retention_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesPreorderPdf.lastPageFooter.discounts")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataSalesPreorders.discount_amount || 0 }) || ' '}</Text>
                        </View>
                    </View>
                    <View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesPreorderPdf.lastPageFooter.subtotal")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataSalesPreorders.subtotal_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesPreorderPdf.lastPageFooter.total")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataSalesPreorders.total_amount || 0 }) || ' '}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>
    )
}
